import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Download } from 'lucide-react';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Separator } from '@/components/ui/separator';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import ThemeSwitcher from '@/components/ThemeSwitcher';
import LangSelector from '@/components/LangSelector';

export default function ChatHeader({ messages = [] }) {
  const { threadId } = useParams();
  const { t } = useTranslation('chat');

  const handleExport = async (format) => {
    const { exportAsText, exportAsMarkdown, downloadFile } = await import(
      '@/shared/utils/exportChat'
    );
    const title = `Zehn AI - ${threadId || 'Chat'}`;
    const content = format === 'md' ? exportAsMarkdown(messages, title) : exportAsText(messages, title);
    const ext = format === 'md' ? 'md' : 'txt';
    downloadFile(content, `chat-export.${ext}`);
  };

  return (
    <header className="flex h-12 shrink-0 items-center gap-2 border-b border-border px-4">
      <SidebarTrigger className="-ml-1" />
      <Separator orientation="vertical" className="mr-2 !h-4" />
      <div className="flex-1" />

      {threadId && messages.length > 0 && (
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" size="icon" className="size-8">
              <Download className="size-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuItem onClick={() => handleExport('txt')}>
              {t('export_text', 'Export as text')}
            </DropdownMenuItem>
            <DropdownMenuItem onClick={() => handleExport('md')}>
              {t('export_markdown', 'Export as Markdown')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      )}

      <ThemeSwitcher />
      <LangSelector />
    </header>
  );
}
